import { useEffect } from "react";
import { applyWindowGlobals } from "../lib/bootConfig";
import { initFavoriteRadioPayload } from "../lib/favoriteRadioPayload";
import { initMusicIdentifier } from "../lib/musicIdentifier";
import { initRadioManager } from "../lib/radioManager";
import { initHomeIndex } from "../lib/homeIndex";
import { initListeningHeartbeat } from "../lib/listeningHeartbeat";
import { initRpGlobe } from "../lib/rpGlobe";
import { initProtonWidget } from "../lib/protonWidget";
import { initWhatsAppToast } from "../lib/whatsappToast";

/** Boot dos módulos TypeScript portados do JS original, após o DOM React da home. */
export function useRadiosLegacyScripts(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    applyWindowGlobals();
    initFavoriteRadioPayload();
    initMusicIdentifier();
    initRadioManager();
    initHomeIndex();
    initListeningHeartbeat();
    initRpGlobe();
    initProtonWidget();
    initWhatsAppToast();

    if (window.matchMedia("(pointer: fine)").matches) {
      const searchInput = document.getElementById("rp-search-input") as HTMLInputElement | null;
      searchInput?.focus({ preventScroll: true });
    }
  }, [enabled]);
}
